import { Button, Col, Form, Row } from "antd";
import React from "react";

import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";

function EvaluateTasks() {
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Evaluate and create tasks:" />
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <p className="pink-info-text">
                  The items on this list should be done right away.{" "}
                </p>
              </Col>
              <Col span={24}>
                <p className="pink-info-text">DO NOT DELAY</p>
              </Col>
              <Col span={24}>
                <p className="pink-info-text">
                  to start these items until just before move out dates. they
                  must be started
                </p>
              </Col>
              <Col span={24}>
                <p className="pink-info-text">RIGHT AWAY!</p>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Next</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default EvaluateTasks;
